export enum SelectOperation {
  SelectAll = 'selectAll',
  DeselectAll = 'deselectAll',
  SelectInverse = 'selectInverse',
}
